module.exports = __webpack_public_path__ + "static/Rani-632143f6d17558734494e58d566c028d.jpg";